import type { ComponentProps } from "solid-js";

export type SurfaceProps = ComponentProps<"section"> & {
  bleed?: boolean;
};

export function Surface(props: SurfaceProps) {
  return (
    <section
      {...props}
      class={`sn-surface ${props.bleed ? "sn-surface--bleed" : ""} ${props.class ?? ""}`.trim()}
    >
      {props.children}
    </section>
  );
}
